import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

export default function AppFooter() {
  return (
    <footer className="border-t border-[#36454F]/10 bg-white mt-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Legal Disclaimer */}
        <div className="mb-6 p-4 bg-[#F5F5F5] rounded-sm border border-[#36454F]/5" data-testid="legal-disclaimer">
          <p className="text-[10px] text-[#36454F]/50 font-['Manrope'] leading-relaxed text-center">
            Selah Slate is a financial wellness initiative of Selah and Stone Legacy Holdings LLC. We are not a credit repair clinic or a law firm. Our services provide educational assistance and dispute documentation based on user-provided information and input. We do not guarantee specific credit score increases. All services are provided free of charge as part of our community legacy mission.
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo & Mission */}
          <div className="flex items-center space-x-3">
            <Shield className="w-6 h-6 text-[#B76E79]" strokeWidth={1.5} />
            <div>
              <span className="font-['Playfair_Display'] text-sm font-semibold text-[#36454F]">
                Selah Slate
              </span>
              <span className="mx-2 text-[#36454F]/20">|</span>
              <span className="text-xs text-[#36454F]/40 font-['Manrope']">
                Free Forever
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-[#36454F]/50 font-['Manrope']">
            <Link to="/faith-strategies" className="hover:text-[#B76E79] transition-colors">Faith Strategies</Link>
            <Link to="/debt-calculator" className="hover:text-[#B76E79] transition-colors">Debt Calculator</Link>
            <Link to="/testimonies" className="hover:text-[#B76E79] transition-colors">Testimonies</Link>
            <Link to="/journal" className="hover:text-[#B76E79] transition-colors">Journal</Link>
            <Link to="/resources" className="hover:text-[#B76E79] transition-colors" data-testid="footer-resources-link">Free Guides</Link>
            <span className="hidden sm:inline text-[#36454F]/15">•</span>
            <Link to="/privacy" className="hover:text-[#B76E79] transition-colors" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/terms" className="hover:text-[#B76E79] transition-colors" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <Link to="/disclosures" className="hover:text-[#B76E79] transition-colors" data-testid="footer-disclosures-link">Disclosures</Link>
            <Link to="/support" className="hover:text-[#B76E79] transition-colors" data-testid="footer-support-link">Help &amp; Support</Link>
            <Link to="/delete-account" className="hover:text-[#B76E79] transition-colors" data-testid="footer-delete-account-link">Delete Account</Link>
          </div>

          {/* Company Branding */}
          <div className="text-center md:text-right">
            <p className="text-[10px] text-[#36454F]/40 font-['Manrope'] tracking-wide">
              Part of Selah &amp; Stone Legacy Holdings
            </p>
            <p className="text-[10px] text-[#36454F]/40 font-['Manrope'] mt-0.5">
              No ads. No fees. No credit card offers.
            </p>
          </div>
        </div>

        {/* Copyright & Trademark Notice */}
        <div className="mt-6 pt-4 border-t border-[#36454F]/5 text-center" data-testid="footer-legal-notice">
          <p className="text-[10px] text-[#36454F]/40 font-['Manrope'] leading-relaxed max-w-3xl mx-auto">
            © {new Date().getFullYear()} Selah &amp; Stone Legacy Holdings LLC.
            Selah Downloads&trade;, Selah Slate&trade;, Selah Rest&trade;, and Selah &amp; Salt Home&trade; are
            proprietary trademarks of Selah &amp; Stone Legacy Holdings LLC.
            All rights reserved. Unauthorized reproduction or reverse engineering of this software codebase is strictly prohibited.
          </p>
        </div>
      </div>
    </footer>
  );
}
